export const GET_SERVICE_PROVIDER_REQUEST = "GET_SERVICE_PROVIDER_REQUEST";
export const ACCEPT_SERVICE_PROVIDER_REQUEST = "ACCEPT_SERVICE_PROVIDER_REQUEST";
export const REJECT_SERVICE_PROVIDER_REQUEST = "REJECT_SERVICE_PROVIDER_REQUEST";
